import React, {useState} from "react";
import {PlusOutlined} from "@ant-design/icons";

import {useTranslation} from "react-i18next";
import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {Form, InputNumber, message, Modal, Tooltip} from "antd";
import {useStore} from "../../../hooks/useStore";
import {calculateKDV, calculateKDVAddedAmount, getKDVPercentage} from "../../../utils/kdvHelper";

const ActionButtons = ({filters}) => {
    const {t} = useTranslation([]);
    const stores = useStore();
    const [isPaymentLinkLoading, setIsPaymentLinkLoading] = React.useState(false);
    const [isCreditModalActive, setIsCreditModalActive] = useState(false);
    const [newCreditAmount, setNewCreditAmount] = useState(0);

    const createPaymentLink = async () => {
        setIsPaymentLinkLoading(true);

        try {
            const response = await stores.companyStore.createPaymentLink({
                subCompanyId: filters?.subCompanyId,
                amount: newCreditAmount
            });

            if (response?.paymentUrl) {
                window.open(response?.paymentUrl, "_blank", "norefferer");
            } else if (Boolean(response)) {
                message.error("Ödeme linki oluşturulurken bir hata oluştu.");
            }
        } catch (error) {
            console.log(error);
            message.error("Ödeme linki oluşturulurken bir hata oluştu.");
        } finally {
            setIsPaymentLinkLoading(false);
        }
    };
    return (
        <>
            <ActionButtonsContainer>
                <Tooltip
                    title={
                        Boolean(filters?.subCompanyId)
                            ? "Ödeme Yap"
                            : "Ödeme yapabilmek için alt firma seçmelisiniz."
                    }
                >
                    <CustomButton
                        type="primary"
                        data-testid="createPaymentLinkButton"
                        onClick={() => setIsCreditModalActive(true)}
                        icon={<PlusOutlined />}
                        disabled={isPaymentLinkLoading || !Boolean(filters?.subCompanyId)}
                    >
                        {isPaymentLinkLoading ? "Ödeme Linki Oluşturuluyor..." : "Ödeme Yap"}
                    </CustomButton>
                </Tooltip>
            </ActionButtonsContainer>
            <Modal
                visible={isCreditModalActive}
                onCancel={() => setIsCreditModalActive(false)}
                centered
                title={"Kredi Yükle"}
                okText={"Tamam"}
                onOk={createPaymentLink}
                cancelText={t("modal.cancelButton2", {ns: "common"})}
                okButtonProps={{loading: isPaymentLinkLoading, disabled: !newCreditAmount}}
            >
                <Form labelCol={{span: 24}} wrapperCol={{span: 24}}>
                    <Form.Item label={"Yüklemek istediğiniz bakiye tutarını giriniz (₺)"}>
                        <InputNumber
                            style={{width: "100%"}}
                            placeholder={"0"}
                            min={0}
                            value={newCreditAmount}
                            onChange={value => setNewCreditAmount(value)}
                        />
                    </Form.Item>
                    <p style={{marginBottom: "0px"}}>KDV (%{getKDVPercentage()})</p>
                    <p>{calculateKDV(newCreditAmount)} ₺</p>

                    <p style={{marginBottom: "0px"}}>
                        <b>KDV Dahil Tutar</b>
                    </p>
                    <p style={{marginBottom: "0px"}}>
                        <b>{calculateKDVAddedAmount(newCreditAmount)} ₺</b>
                    </p>
                </Form>
            </Modal>
        </>
    );
};

export default ActionButtons;
